import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ToggleSwitch from "../../components/common/ToggleSwitch.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isGridView: true,
      isAllowForEditing: false,
      isPharmaSoftware: false,
      _id: "",
      searchByItemName: "",
      tableStatus: "",
      isLoading: false,
      totalCount: 0,
      productDetailsList: [],
      itemCategoryList: [],
      colorMasterList: [],
      storageConditionList: [],
      partyDropdownList: [],
      punchSizeList: [],
      stereoDataList: [],
      mfgLicList: [],
      labelClaimList: [],
      exportLocal: [{ exportLocal: "LOCAL" }, { exportLocal: "EXPORT" }],
      productDetails: {
        productName: "",
        expiryMonth: 0,
        masterCardNo: "",
        effectiveDate: new Date(),
        productSpecification: "",
        productCategory: "",
        color: "",
        storageCondition: "",
        labelClaimTitle: "",
        prtyname: "",
        sizeName: "",
        stereo: "",
        exportLocal: "",
        sampleQty: 0,
        weight: 0,
        testchg: 0,
        mfgLicNo: "",
        productNote: "",
        labTestRequire: 0,
      },
      validationRules: {
        productName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };

  }

  componentDidMount() {
    if (!this.isCalled) {
      this.isCalled = true;
      this.setState({ productDetailsList: [] }, () => {
        this.getAllProductDetails(this.state.searchByItemName);
      });
    }

    let cookies = getAuthProps()
    if (cookies) {
      this.setState({ isPharmaSoftware: cookies.isPharmaSoftware })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchByItemName !== this.state.searchByItemName && !this.isCalled) {
      this.isCalled = true;
      this.setState({ productDetailsList: [] }, () => {
        this.getAllProductDetails(this.state.searchByItemName);
      });
    }
  }

  getAllProductDetails = (searchName) => {
    this.setState({ tableStatus: "Loading..." })
    let request = [searchName];

    this.itemMasterServices.getAllProductDetails(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let totalCount = response.responseData.totalCount;
        if (totalCount === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        const newMaterials = response.responseData.responseData;

        this.setState({ productDetailsList: newMaterials, totalCount, totalCount }, () => {
          this.getAllItemCategory();
        })

      } else {
        this.setState({ tableStatus: "" })
        this.getAllItemCategory();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllItemCategory = () => {
    this.commonServices.getAllItemCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState(
          { itemCategoryList: response.responseData },
          () => {
            this.getAllColors();
          }
        );
      } else {
        this.getAllColors();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllColors = () => {
    this.commonServices.getAllColors().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState(
          { colorMasterList: response.responseData },
          () => {
            this.getAllStorageConditions();
          }
        );
      } else {
        this.getAllStorageConditions();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllStorageConditions = () => {
    this.commonServices.getAllStorageConditions().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState(
          { storageConditionList: response.responseData },
          () => {
            this.getAllLabelClaims();
          }
        );
      } else {
        this.getAllLabelClaims();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllLabelClaims = () => {
    this.commonServices.getAllLabelClaims().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ labelClaimList: response.responseData }, () => {
          this.getAllPartyDropdown();
        });
      } else {
        this.getAllPartyDropdown();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState(
          { partyDropdownList: response.responseData },
          () => {
            this.getAllPunchSizes();
          }
        );
      } else {
        this.getAllPunchSizes();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPunchSizes = () => {
    this.commonServices.getAllPunchSizes().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ punchSizeList: response.responseData }, () => {
          this.getAllStereoData();
        });
      } else {
        this.getAllStereoData();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllStereoData = () => {
    this.commonServices.getAllStereoData().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ stereoDataList: response.responseData }, () => {
          this.getAllMfgLicMaster();
        });
      } else {
        this.getAllMfgLicMaster();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllMfgLicMaster = () => {
    this.commonServices.getAllMfgLicMaster().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ mfgLicList: response.responseData }, () => { });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllProductDetails(this.state.searchByItemName);
    });
  };

  handleDropdownChange = (e, name) => {
    const selectedYear = e.target.value;

    let details = this.state.productDetails;
    details[name] = selectedYear;
    this.setState({ productDetails: details });

  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.productDetails;
    if (name !== "effectiveDate") {
      details[name] = value.toUpperCase();
    } else {
      details[name] = value;
    }
    this.setState({ productDetails: details });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false, isAllowForEditing: false });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.productDetails;
    details.productName = "";
    details.expiryMonth = 0;
    details.masterCardNo = "";
    details.effectiveDate = "";
    details.productSpecification = "";
    details.productCategory = "";
    details.color = "";
    details.storageCondition = "";
    details.labelClaimTitle = "";
    details.prtyname = "";
    details.sizeName = "";
    details.stereo = "";
    details.exportLocal = "";
    details.sampleQty = 0;
    details.weight = 0;
    details.testchg = 0;
    details.labTestRequire = false;
    this.setState({ productDetails: details, _id: "", validState: validState, searchByItemName: "", tableStatus: "", isEditing: false },
      () => {
        this.getAllProductDetails(this.state.searchByItemName);
      });

  };

  getProductDetailById = (id) => {
    this.itemMasterServices.getProductDetailById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;

        const date = new Date(response.responseData.effectiveDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;

        details.effectiveDate = formatedDate

        if (details.exportLocal === "0") {
          details.exportLocal = "LOCAL";
        }
        details.labTestRequire = details.labTestRequire ? 1 : 0;
        this.setState({ productDetails: details, _id: details._id }, () => {
          this.setState({ isEditing: true, isGridView: false, isAllowForEditing: true });
        });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  deleteProductDetailsById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete this product?`
    ).then((response) => {
      if (response === true) {
        this.itemMasterServices.deleteProductDetailsById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.setState({ searchByItemName: '' }, () => {
              this.getAllProductDetails(this.state.searchByItemName);
            })
          } else {
            this.SwalServices.Error(
              response.Message
            );
          }
        });
      }
    });
  }

  addEditProductDetails = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.productDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        request.labTestRequire = request.labTestRequire ? true : false;
        this.itemMasterServices
          .addEditProductDetails(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              this.SwalServices.Success(response.Message);
              this.resetForm();
              this.setState({ isGridView: true, searchByItemName: '', isLoading: false }, () => {
                this.getAllProductDetails(this.state.searchByItemName);
              });
            } else if (response.statusCode === 409) {
              this.SwalServices.Warning(response.Message);
              this.setState({ isGridView: true, isLoading: false, })
            } else {
              this.SwalServices.Error(response.Message);
              this.setState({ isLoading: false })
            }
          });
      });
    }
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.productDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  copyItem = () => {
    let details = this.state.productDetails
    details.productName = ''
    this.setState({ productDetails: details, _id: '', isEditing: false })
  }

  handleToggle = (e) => {
    let checked = e.target.checked;
    this.setState({
      productDetails: {
        ...this.state.productDetails,
        labTestRequire: checked ? 1 : 0
      }
    });
  }

  render() {
    return (
      <div className="productDetails-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-2.5">
              <div className="item-grp">
                <div className="item-search-box  w-[50%]">
                  <label>Item name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    autocomplete="off"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
              </div>
              <button className="add-btn mt-3.5" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
              <div className="table-container" style={{ height: "calc(100vh - 205px)" }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: '35%' }}>Product Name</td>
                      <td style={{ width: '10%' }}>Specification</td>
                      <td style={{ width: '10%' }}>Color</td>
                      <td style={{ width: '10%' }}>Size</td>
                      <td style={{ width: '13%' }}>Mfg.Lic. No</td>
                      <td style={{ width: '10%' }}>Expiry(Months)</td>
                      <td style={{ width: '12%', textAlign: 'center' }}>Action</td>
                    </tr>
                  </thead>
                  {this.state.productDetailsList &&
                    this.state.productDetailsList.length > 0 ? (
                    this.state.productDetailsList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td>{item.productName}</td>
                          <td>{item.productSpecification}</td>
                          <td>{item.color}</td>
                          <td>{item.sizeName}</td>
                          <td>{item.mfgLicNo}</td>
                          <td>{item.expiryMonth}</td>
                          <td style={{ textAlign: 'center' }}>
                            <button
                              className="search-btn"
                              onClick={() =>
                                this.getProductDetailById(item._id)
                              }
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.deleteProductDetailsById(item._id)
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.productDetailsList
                    && this.state.productDetailsList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.productDetailsList
                    && this.state.productDetailsList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table mb-3.5">
                <div className="item-grp grid !grid-cols-4 !gap-2.5 mb-3">
                  <div className="input-grp col-span-2">
                    <label>Product Name</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.productName ? "errorInput" : ""}`}
                      type="text"
                      id="productName"
                      name="productName"
                      autocomplete="off"
                      value={this.state.productDetails.productName}
                      onChange={(event) =>
                        this.handleChange(event, "productName")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.productName}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Expiry(Months)</label>
                    <input
                      className="inputFocus"
                      type="number"
                      id="expiryMonth"
                      name="expiryMonth"
                      autocomplete="off"
                      value={this.state.productDetails.expiryMonth}
                      onChange={(event) =>
                        this.handleChange(event, "expiryMonth")
                      }
                    />

                  </div>
                  <div className="input-grp">
                    <label>Effective Date</label>
                    <input
                      className="inputFocus"
                      type="date"
                      id="effectiveDate"
                      name="effectiveDate"
                      autocomplete="off"
                      value={this.state.productDetails.effectiveDate}
                      onChange={(event) =>
                        this.handleChange(event, "effectiveDate")
                      }
                    />

                  </div>
                  <div className="input-grp">
                    <label>Master-Card No</label>
                    <input
                      className="inputFocus"
                      type="text"
                      id="masterCardNo"
                      name="masterCardNo"
                      autocomplete="off"
                      value={this.state.productDetails.masterCardNo}
                      onChange={(event) =>
                        this.handleChange(event, "masterCardNo")
                      }
                    />
                  </div>
                  <div className="input-grp">
                    <label>Specification</label>
                    <input
                      className="inputFocus"
                      type="text"
                      id="productSpecification"
                      name="productSpecification"
                      autocomplete="off"
                      value={this.state.productDetails.productSpecification}
                      onChange={(event) =>
                        this.handleChange(event, "productSpecification")
                      }
                    />

                  </div>
                  <div className="input-grp">
                    <label>Category</label>
                    <select
                      name="productCategory"
                      value={this.state.productDetails.productCategory}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "productCategory")
                      }
                    >
                      <option>Select</option>
                      {this.state.itemCategoryList.map((x, key) => (
                        <option key={key} value={x.categoryName}>
                          {x.categoryName}
                        </option>
                      ))}
                    </select>

                  </div>
                  <div className="input-grp">
                    <label>Color</label>
                    <select
                      name="color"
                      value={this.state.productDetails.color}
                      onChange={(e) => this.handleDropdownChange(e, "color")}
                    >
                      <option>Select</option>
                      {this.state.colorMasterList
                        ? this.state.colorMasterList.map((x, key) => (
                          <option key={key} value={x.colorMaster}>
                            {x.colorMaster}
                          </option>
                        ))
                        : null}
                    </select>

                  </div>
                  <div className="input-grp">
                    <label>Storage Condition</label>
                    <select
                      name="storageCondition"
                      value={this.state.productDetails.storageCondition}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "storageCondition")
                      }
                    >
                      <option>Select</option>
                      {this.state.storageConditionList &&
                        this.state.storageConditionList.map((x, key) => (
                          <option key={key} value={x.storageCondition}>
                            {x.storageCondition}
                          </option>
                        ))}
                    </select>

                  </div>
                  <div className="input-grp">
                    <label>Lable Claim Title</label>
                    <select
                      name="labelClaimTitle"
                      value={this.state.productDetails.labelClaimTitle}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "labelClaimTitle")
                      }
                    >
                      <option>Select</option>
                      {this.state.labelClaimList &&
                        this.state.labelClaimList.map((x, key) => (
                          <option key={key} value={x.labelClaim}>
                            {x.labelClaim}
                          </option>
                        ))}
                    </select>

                  </div>
                  <div className="input-grp">
                    <label>Marketed By</label>
                    <select
                      name="prtyname"
                      value={this.state.productDetails.prtyname}
                      onChange={(e) => this.handleDropdownChange(e, "prtyname")}
                    >
                      <option>Select</option>
                      {this.state.partyDropdownList &&
                        this.state.partyDropdownList.map((x, key) => (
                          <option key={key} value={x.partyName}>
                            {x.partyName}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="input-grp">
                    <label>Size</label>
                    <select
                      name="sizeName"
                      value={this.state.productDetails.sizeName}
                      onChange={(e) => this.handleDropdownChange(e, "sizeName")}
                    >
                      <option>Select</option>
                      {this.state.punchSizeList &&
                        this.state.punchSizeList.map((x, key) => (
                          <option key={key} value={x.punchSizeMaster}>
                            {x.punchSizeMaster}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="input-grp">
                    <label>Stereo</label>
                    <select
                      name="stereo"
                      value={this.state.productDetails.stereo}
                      onChange={(e) => this.handleDropdownChange(e, "stereo")}
                    >
                      <option>Select</option>
                      {this.state.stereoDataList &&
                        this.state.stereoDataList.map((x, key) => (
                          <option key={key} value={x.stereoName}>
                            {x.stereoName}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="input-grp">
                    <label>Mfg. Lic. No</label>
                    <select
                      name="mfgLicNo"
                      value={this.state.productDetails.mfgLicNo}
                      onChange={(e) => this.handleDropdownChange(e, "mfgLicNo")}
                    >
                      <option>Select</option>
                      {this.state.mfgLicList &&
                        this.state.mfgLicList.map((x, key) => (
                          <option key={key} value={x.mfgLicMaster}>
                            {x.mfgLicMaster}
                          </option>
                        ))}
                    </select>

                  </div>
                  <div className="input-grp">
                    <label>Export/Local</label>
                    <select
                      name="exportLocal"
                      value={this.state.productDetails.exportLocal}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "exportLocal")
                      }
                    >
                      <option>Select</option>
                      {this.state.exportLocal &&
                        this.state.exportLocal.map((x, key) => (
                          <option key={key} value={x.exportLocal}>
                            {x.exportLocal}
                          </option>
                        ))}
                    </select>

                  </div>
                  <div className="input-grp">
                    <label>Sample Qty.</label>
                    <input
                      className="inputFocus"
                      type="number"
                      id="sampleQty"
                      name="sampleQty"
                      autocomplete="off"
                      value={this.state.productDetails.sampleQty}
                      onChange={(event) =>
                        this.handleChange(event, "sampleQty")
                      }
                    />
                  </div>
                  <div className="input-outer grid !gap-2.5">
                    <div className="input-grp">
                      <label>Weight/Unit(mm)</label>
                      <input
                        className="inputFocus"
                        type="number"
                        id="weight"
                        name="weight"
                        autocomplete="off"
                        value={this.state.productDetails.weight}
                        onChange={(event) => this.handleChange(event, "weight")}
                      />
                    </div>
                    <div className="input-grp">
                      <label>Testing Charge</label>
                      <input
                        className="inputFocus"
                        type="number"
                        id="testchg"
                        name="testchg"
                        autocomplete="off"
                        value={this.state.productDetails.testchg}
                        onChange={(event) => this.handleChange(event, "testchg")}
                      />
                    </div>
                  </div>
                  <div className="input-grp col-span-3">
                    <label>Note</label>
                    <textarea
                      rows={4}
                      className="inputFocus"
                      type="text"
                      id="productNote"
                      name="productNote"
                      autocomplete="off"
                      value={this.state.productDetails.productNote}
                      onChange={(event) => this.handleChange(event, "productNote")}
                    />
                  </div>
                  {this.state.isPharmaSoftware ?
                    <div className="input-grp flex items-center gap-2">
                      <label className="!mb-0 whitespace-nowrap">Lab test require</label>
                      <ToggleSwitch
                        checked={this.state.productDetails.labTestRequire === 1}
                        onChange={this.handleToggle}
                      />
                    </div>
                    : null}
                  <div className="itemInner-grp grid grid-cols-2 !gap-2.5">

                  </div>
                </div>
              </div>
              <div className="btn-grp">
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditProductDetails()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditProductDetails()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  className="cancel-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.openGridView()}
                >
                  Cancel
                </button>
                {this.state.isAllowForEditing ?
                  <button
                    disabled={this.state.isLoading}
                    className="search-btn !ml-[0]"
                    onClick={() => this.copyItem()}
                  >
                    Copy
                  </button>
                  : null}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ProductDetails;
